import React, { useState, useEffect } from "react";
import { Box, TextField, Typography, Button, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "@mui/material/styles";
import Drawer from "@mui/material/Drawer";
import { get, post, put } from "../../../../../utils/api";
import { companyId } from "../../../../../utils/companyId";
import { textError } from "../../../../../utils/validationMessage";
import EditDialog from "../../../../../Components/Common/EditDialog";

function AddVendor(props) {
  const [isFormModified, setIsFormModified] = useState(false);
  const [editDialog, setEditDialog] = useState(false);
  const [alreadyVendor, setAlreadyVendor] = useState(false);
  const [vendorsList, setVendorsList] = useState([]);
  const [errors, setErrors] = useState({});
  const initialState = {
    company: companyId,
    VendorLegalFullName: "",
  };
  const resetForm = () => {
    setFromValue(
      props.selectedVendor?._id === undefined
        ? initialState
        : props.selectedVendor
    );
    setErrors({});
  };

  const [fromValue, setFromValue] = useState(initialState);

  useEffect(() => {
    // Fetch the list of vendors once when the component loads
    const fetchVendors = async () => {
      try {
        const response = await get(`/master/Electricity/getVendor`);
        setVendorsList(response.data.data || []);
      } catch (error) {
        console.error("Error fetching vendors list:", error);
      }
    };
    fetchVendors();
  }, []);

  useEffect(() => {
    setFromValue({
      company: companyId,
      VendorLegalFullName: props.selectedVendor?.VendorLegalFullName ?? "",
    });
    setAlreadyVendor(props.selectedVendor === null ? false : true);
  }, [props.selectedVendor]);

  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   console.log("nam===e", name, value);
  //   setFromValue({
  //     ...fromValue,
  //     [name]: value,
  //   });

  // };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFromValue({
      ...fromValue,
      [name]: value,
    });
    setIsFormModified(true);

    // Validate onChange
    const newErrors = {};

    if (name === "VendorLegalFullName") {
      if (!value || value.trim() === "") {
        newErrors.VendorLegalFullName = textError;
      } else {
        const vendorExists = vendorsList.some(
          (vendor) =>
            vendor.VendorLegalFullName.toLowerCase() === value.toLowerCase()
        );
        if (vendorExists) {
          newErrors.VendorLegalFullName = "Vendor already exists";
        }
      }
    }
    setErrors(newErrors);
  };

  const handleCloseDrawer = () => {
    if (isFormModified) {
      setEditDialog(true); // Show the edit dialog
    } else {
      props.setAddVendor(false);
      resetForm();
    }
  };

  const handleExitAgree = (action) => {
    setEditDialog(false); // Close the dialog

    if (action === "save") {
      Save(); // Save the changes
      props.setAddVendor(false);
      resetForm(); // Reset the form
    } else if (action === "discard") {
      props.setAddVendor(false);
      resetForm(); // Reset the form
    }
    // If action is 'cancel', do nothing (dialog is already closed)
  };

  const validateForm = () => {
    const newErrors = {};
    const { VendorLegalFullName } = fromValue;

    if (!VendorLegalFullName || VendorLegalFullName.trim() === "") {
      newErrors.VendorLegalFullName = textError;
    } else {
      // Case-insensitive check for existing vendor name
      const vendorExists = vendorsList.some(
        (vendor) =>
          vendor.VendorLegalFullName.toLowerCase() ===
          VendorLegalFullName.toLowerCase()
      );
      if (vendorExists) {
        newErrors.VendorLegalFullName = "Vendor already exists";
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const Save = async () => {
    if (!validateForm()) return;

    let method = alreadyVendor ? put : post;
    let url = alreadyVendor
      ? `/master/Electricity/updateVendor?Id=${props.selectedVendor?._id}`
      : `/master/Electricity/creatVendor`;

    await method(url, fromValue)
      .then((res) => {
        console.log(res, res.data.data);
        props.setAddVendor(false);
        props.fetchSteamVendor();
        resetForm();
        props.setsnackOpen({
          open: true,
          message: res.data.message,
          severity: "success",
        });
        setFromValue((prev) => ({ ...prev }));
      })
      .catch((err) => {
        console.log(err);
        if (
          err?.response?.data?.message &&
          err.response.data.message !== "Vendor already exists"
        ) {
          setErrors({
            ...errors,
            VendorLegalFullName: "Vendor already exists",
          });
        }
      });
  };

  const list = () => (
    <Box
      display="flex"
      gap={3}
      sx={{
        width: "26.5rem",
        // maxWidth:"100%",
        height: "100vh",
        display: "flex",
        justifyContent: "space-btween",
        backgroundColor: "transparent",
      }}
    >
      <Box
        sx={{
          backgroundColor: "#fff",
          height: "3%",
          padding: "13px",
          margin: "30px 0 0 0",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "80%",
          width: "5%",
        }}
      >
        <IconButton
          // onClick={() => {
          //   props.setAddVendor(false);
          //   resetForm();
          // }}
          onClick={handleCloseDrawer}
          sx={{ color: "black" }}
        >
          <CloseIcon sx={{ fontSize: "1.2rem" }} />
        </IconButton>
      </Box>
      <Box
        sx={{
          padding: "24px",
          backgroundColor: "#fff",
          height: "100%",
          width: "100%",
          overflowY: "scroll",
        }}
      >
        <Typography
          variant="h6"
          sx={{
            textDecoration: "underline",
            fontWeight: "bold",

            mb: 2,
          }}
        >
          {props.selectedVendor?._id === undefined
            ? " Add Electricity Vendor"
            : "Edit Electricity Vendor"}
        </Typography>

        <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
          Vendor Legal Full Name
        </Typography>

        <CustomTextField
          //   select
          variant="outlined"
          value={fromValue.VendorLegalFullName}
          onChange={handleChange}
          fullWidth
          name="VendorLegalFullName"
          placeholder="Full Name"
          error={!!errors.VendorLegalFullName} // Show error styling if there's an error
          InputLabelProps={{
            style: {
              color: errors.VendorLegalFullName ? "#D34040" : undefined,
            },
          }}
        ></CustomTextField>
        {errors.VendorLegalFullName && (
          <Typography variant="body2" color="#D34040">
            {errors.VendorLegalFullName}
          </Typography>
        )}

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            minHeight: "70%", // Ensures the box takes up the full height of the page
          }}
        >
          {/* Other content goes here */}

          <Box
            sx={{
              marginTop: "auto", // Pushes the button to the bottom
              // textAlign: 'center', // Center the button horizontally
            }}
          >
            <Button
              variant="contained"
              sx={{
                backgroundColor: "#0a3f73",
                textTransform: "none",
                marginTop: "10%", // Can adjust this to control spacing
              }}
              onClick={Save}
            >
              Submit
            </Button>
          </Box>
        </Box>

        {/* </Box> */}
      </Box>
    </Box>
  );

  return (
    <div>
      <Drawer
        sx={{
          backgroundColor: "transparent",
          "& .MuiDrawer-paper": {
            // This targets the paper component within the Drawer
            backgroundColor: "transparent", // Make paper transparent
            boxShadow: "none", // Optional: Remove any shadow
          },
        }}
        anchor="right"
        open={props.addVendor}
        // onClose={() => {
        //   props.setAddVendor(false);
        //   resetForm();
        // }}
        onClose={handleCloseDrawer}
      >
        {list()}
      </Drawer>
      {editDialog && (
        <EditDialog
          editDialog={editDialog}
          setEditDialog={setEditDialog}
          handleExitAgree={handleExitAgree}
        />
      )}
    </div>
  );
}

export default AddVendor;

//// custom textfield

const CustomTextField = styled(TextField)(({ theme }) => ({
  "& .MuiInputBase-root": {
    height: "40px", // Adjust height as needed
  },
  "& .MuiSelect-select": {
    height: "56px", // Adjust height as needed
    display: "flex",
    alignItems: "center",
  },
}));
